import { api } from "@/lib/apiClient";

export interface EmployeeOooAdminRow {
  user_login: string;
  user_display: string | null;
  email: string | null;
  automation_enabled: boolean;
  substitute_login: string | null;
  substitute_display: string | null;
  last_sync_at: string | null;
  last_sync_status: string | null;
  last_sync_error: string | null;
}

export interface EmployeeOooMeSettings {
  user_login: string;
  user_display: string | null;
  automation_enabled: boolean;
  substitute_login: string | null;
  substitute_display: string | null;
  can_edit_substitute: boolean;
  last_sync_at: string | null;
  last_sync_status: string | null;
  last_sync_error: string | null;
}

export interface EmployeeOooPeriod {
  work_start: string;
  work_end: string;
  display_start: string;
  display_end: string;
}

export interface EmployeeOooSubstitute {
  login: string;
  display: string;
  email: string;
  phone?: string;
}

export interface EmployeeOooPreview {
  automation_enabled: boolean;
  active_period: EmployeeOooPeriod | null;
  substitute: EmployeeOooSubstitute | null;
  internal_message: string;
  external_message: string;
  all_staff_absent_today: boolean;
}

export async function listOooAdminSettings(): Promise<EmployeeOooAdminRow[]> {
  return api.get<EmployeeOooAdminRow[]>("/employee-times/ooo-settings/admin");
}

export async function updateOooAdminSettings(
  items: Array<{ user_login: string; automation_enabled: boolean }>,
): Promise<EmployeeOooAdminRow[]> {
  return api.put<EmployeeOooAdminRow[]>("/employee-times/ooo-settings/admin", { items });
}

export async function getMyOooSettings(): Promise<EmployeeOooMeSettings> {
  return api.get<EmployeeOooMeSettings>("/employee-times/ooo-settings/me");
}

export async function updateMyOooSettings(payload: {
  substitute_login: string | null;
  substitute_display: string | null;
}): Promise<EmployeeOooMeSettings> {
  return api.put<EmployeeOooMeSettings>("/employee-times/ooo-settings/me", payload);
}

export async function previewMyOooSettings(onDate?: string): Promise<EmployeeOooPreview> {
  const query = onDate ? `?on_date=${encodeURIComponent(onDate)}` : "";
  return api.get<EmployeeOooPreview>(`/employee-times/ooo-settings/me/preview${query}`);
}

export async function syncMyOooSettings(): Promise<{ ok: boolean; mailbox_upn?: string | null }> {
  return api.post("/employee-times/ooo-settings/me/sync");
}

export async function syncOooSettings(): Promise<{
  ok: boolean;
  processed: number;
  updated: number;
  disabled: number;
  errors: Array<{ user_login: string; error: string }>;
}> {
  return api.post("/employee-times/ooo-settings/sync");
}

export function formatOooPeriod(period: EmployeeOooPeriod | null): string {
  if (!period) return "—";
  const fmt = (iso: string) => {
    const [y, m, d] = iso.slice(0, 10).split("-");
    return `${d}.${m}.${y}`;
  };
  return `${fmt(period.display_start)} – ${fmt(period.display_end)}`;
}
